module.exports = __webpack_public_path__ + "media/images/pfeil-nach-oben-1673bd248993023edacbab44b634beb4.png";